import React, { useCallback, useEffect, useState } from "react";
import { getPopupList } from "api/newPopupApi";
import { NewPopupList } from "types/newPopup";

const HIDE_TIME = 24 * 60 * 60 * 1000; // 24시간
const hideKey = (id: number) => `popupNoShow_${id}`;

export const useNewPopup = () => {
  const [data, setData] = useState<NewPopupList[]>([]);

  // 팝업 조회
  const fetchPopups = useCallback(async () => {
    const param = {
      systemType: "P",
    };

    try {
      const res = await getPopupList(param);
      setData(res.data.dateList);
    } catch (e) {
      console.error("팝업 정보를 불러오지 못했습니다.", e);
    }
  }, []);

  useEffect(() => {
    fetchPopups();
  }, [fetchPopups]);

  // 오늘하루 안보기
  const hidePopupToday = (id: number) => {
    const expire = Date.now() + HIDE_TIME;
    localStorage.setItem(hideKey(id), expire.toString());
    setData((prev) => prev.filter((p) => p.id !== id));
  };

  // 닫기
  const closePopup = (id: number) => {
    setData((prev) => prev.filter((p) => p.id !== id));
  };

  // 만료시간 비교
  const isHidden = (id: number) => {
    const str = localStorage.getItem(hideKey(id));
    return str !== null && Date.now() < parseInt(str, 10);
  };

  // 렌더링할 팝업 필터링
  const popups = data.filter(
    (p) => typeof p.id === "number" && !isHidden(p.id),
  );

  return { popups, hidePopupToday, closePopup };
};
